import { useState } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import Paragraph from 'components/typography/Paragraph'

import Header from 'components/typography/Header'
import Link from 'components/misc/Link'
import Feature from './Feature'
import Dropdown from './Dropdown'
import styles from './styles/ResourceDropdown.css'
import commonStyles from './styles/DropdownCommon.css'

export const ResourceDropdown = () => {
  const [open, setOpen] = useState(false)

  const browser = useSelector(({ ui }) => ui.browser?.name)
  const links = {
    chrome: CONFIG.plugin.chromeLink,
    firefox: CONFIG.plugin.firefoxLink,
    safari: CONFIG.plugin.safariLink
  }

  return (
    <Dropdown open={open} setOpen={setOpen} title='Resources'>
      <div className={styles.grid}>
        <div className={commonStyles.features}>
          <Feature
            href='https://help.scite.ai'
            header='Help & FAQ'
          >
            Learn more about how scite works and get help with scite tools
          </Feature>
          <Feature
            to='/apiterms'
            header='API, Badge, Embeddable Search'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
          >
            Get access to or embed scite data
          </Feature>
          <Feature
            to='/partners/publishers'
            header='For Publishers'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
          >
            Make your content discoverable, understand your journals, and track how articles are cited over time
          </Feature>
          <Feature
            to='/partners/students'
            header='For Students'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
          >
            Know exactly what you should be citing
          </Feature>
          <Feature
            to='/partners/academic-institutions'
            header='For Universities & Libraries'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
          >
            Provide your researches with tools to improve their work
          </Feature>
          <Feature
            to='/partners/pharma-and-biotech'
            header='For Pharmaceuticals & Biotech'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
          >
            Stay on top of how your research assets are being used
          </Feature>
        </div>
        <Link href={links[browser]}>
          <div className={classNames(styles.featured, styles.featued1)}>
            <Header className={commonStyles.header} level={6}>
              Install our browser extension!
            </Header>
            <img alt='browser extension' className={styles.badgeIllo} src={`${CONFIG.assetsBaseURL}/images/illustrations/resource-badge.svg?v=1`} />
            <Paragraph type='bodyLeft'>
              The scite browser extension allows you to see Smart Citations anywhere you're reading a scientific article online.
            </Paragraph>
            {browser in links && <span className={styles.linkFeatured}>Download our browser extension<i className={`icon icon-right-arrow ${styles.arrowImg}`} /></span>}
          </div>
        </Link>
        <Link href='https://doi.org/10.1162/qss_a_00146' target='_blank' rel='noopener noreferrer'>
          <div className={classNames(styles.featured, styles.featured2)}>
            <Header className={commonStyles.header} level={6}>
              How scite works
            </Header>
            <img alt='how scite works' className={styles.methodIllo} src={`${CONFIG.assetsBaseURL}/images/illustrations/matter-illo.png`} />
            <Paragraph type='bodyLeft'>
              Read about the technical details powering scite
            </Paragraph>
            <span className={styles.linkFeatured}>Read our publication <i className={`icon icon-right-arrow ${styles.arrowImg}`} /></span>
          </div>
        </Link>
      </div>
    </Dropdown>
  )
}

export default ResourceDropdown
